import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'convertPrice',
})
export class ProductPricePipe implements PipeTransform {
  transform(value: any) {
    if (!value) return null;
    const thousandthEnabled = 0 > value;
    const decimalDigit = thousandthEnabled ? 1000 : 100;
    let data = value * decimalDigit;
    return parseInt(`${data}`) / decimalDigit;
  }
}
